import React, { useState } from "react";
import { isEqual } from "lodash";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import IconButton from "@mui/material/IconButton";
import ListSubheader from "@mui/material/ListSubheader";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Button from "@mui/material/Button";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Placeholder } from "./Placeholder";
import RoleBasedContent from "../../features/contents/RoleBasedContent";

const ListHeader = ({ title, onNewClick }) => {
  return (
    <ListSubheader disableGutters>
      <Stack
        direction="row"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
        }}
      >
        <Typography
          variant="h5"
          noWrap
          sx={{
            mr: 2,
            display: { xs: "none", md: "flex" },
            fontWeight: 700,
            letterSpacing: ".3rem",
            textDecoration: "none",
          }}
          color="primary"
        >
          {title}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          sx={{
            marginRight: "14px",
            "& .MuiButton-startIcon": { position: "relative", bottom: "1px" },
          }}
          onClick={onNewClick}
        >
          New
        </Button>
      </Stack>
    </ListSubheader>
  );
};

const Item = ({
  item,
  onEditClick,
  onDeleteClick,
  selected,
  itemType,
  itemText,
}) => {
  const ItemText = itemText;

  return (
    <ListItem divider dense selected={selected} sx={{ pr: "28%" }}>
      {itemText && <ItemText item={item} />}
      {itemType === "machine" && (
        <ListItemText
          primary={item.title || "null"}
          secondary={`${item.model || "null"} - ${item.dsn || "null"} - ${
            item.country || "null"
          }  ${item.ela ? "- Ela" : ""}`}
        />
      )}

      {itemType === "recipe" && (
        <ListItemText
          primary={item.id || "null"}
          secondary={item.recipeName || "null"}
        />
      )}
      {itemType === "mapping" && (
        <ListItemText
          primary={item.title || "null"}
          secondary={item.dsn || "null"}
        />
      )}

      <ListItemSecondaryAction>
        <Stack direction="row" spacing={1}>
          <IconButton edge="end" aria-label="edit" onClick={onEditClick}>
            <EditIcon />
          </IconButton>
          <RoleBasedContent>
            <IconButton edge="end" aria-label="edit" onClick={onDeleteClick}>
              <DeleteIcon />
            </IconButton>
          </RoleBasedContent>
        </Stack>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export const HOCList = ({
  data,
  style = null,
  header,
  isLoading,
  itemType,
  onNewClick = () => {},
  onEditClick,
  onDeleteClick,
  disableHeader = false,
  itemText = null,
}) => {
  const [selectedItem, setSelectedItem] = useState([]);

  return (
    <List
      style={
        !style
          ? {
              maxHeight: 310,
              overflow: "auto",
              width: "100%",
              marginRight: "2px",
            }
          : style
      }
      subheader={
        !disableHeader && <ListHeader title={header} onNewClick={onNewClick} />
      }
    >
      {!data && !isLoading && (
        <Placeholder placeholderText="No items for this list, create the first!" />
      )}
      {isLoading && <Skeleton width={"100%"} height={"100%"} />}
      {data &&
        !isLoading &&
        data.map((item, index) => (
          <Item
            key={index}
            item={item}
            itemType={itemType}
            itemText={itemText}
            onEditClick={() => {
              setSelectedItem(item);
              onEditClick(item);
            }}
            onDeleteClick={() => onDeleteClick(item)}
            selected={isEqual(selectedItem, item)}
          />
        ))}
    </List>
  );
};
